// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .actions {
  display: inline-block;
  vertical-align: bottom;
  line-height: 38px;
  margin-right: 24px;
}
.presize-root .actions .separator {
  display: inline-block;
  vertical-align: middle;
  border-left: 1px solid #E3E3E3;
  height: 32px;
}
.presize-root .actions .spacing {
  display: inline-block;
  margin: 0 8px;
}
.presize-root .actions .total .total-sign {
  margin: 0 16px;
}
.presize-root .actions .total .red {
  color: #AD6800;
}
.presize-root .actions .total .green {
  color: #5AA64B;
}
.presize-root .matrix-2d + .actions {
  margin-bottom: 8px;
}
.presize-root .edit-sizes-btn {
  line-height: 38px;
}
/*# sourceMappingURL=Actions.css.map */`, "",{"version":3,"sources":["webpack://./Actions.less","webpack://./src/components/Matrices/Matrix/Actions/Actions.less"],"names":[],"mappings":"AAAA;EAEE,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;ACAF;ADLA;EAOI,qBAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;ACCJ;ADXA;EAaI,qBAAA;EACA,aAAA;ACCJ;ADfA;EAkBM,cAAA;ACAN;ADlBA;EAqBM,cAAA;ACAN;ADrBA;EAwBM,cAAA;ACAN;ADxBA;EA6BE,kBAAA;ACFF;AD3BA;EAgCE,iBAAA;ACFF;AACA,sCAAsC","sourcesContent":[".presize-root { \n .actions {\n  display: inline-block;\n  vertical-align: bottom;\n  line-height: 38px; // Align center with table row\n  margin-right: 24px; // Get some space to right when exceeding screen width\n  .separator {\n    display: inline-block;\n    vertical-align: middle;\n    border-left: 1px solid #E3E3E3;\n    height: 32px;\n  }\n  .spacing {\n    display: inline-block;\n    margin: 0 8px;\n  }\n  .total {\n    .total-sign {\n      margin: 0 16px;\n    }\n    .red {\n      color: #AD6800;\n    }\n    .green {\n      color: #5AA64B;\n    }\n  }\n}\n.matrix-2d + .actions {\n  margin-bottom: 8px; // Same margin as table\n}\n.edit-sizes-btn {\n  line-height: 38px; // Align center with table row\n}\n \n}",".presize-root .actions {\n  display: inline-block;\n  vertical-align: bottom;\n  line-height: 38px;\n  margin-right: 24px;\n}\n.presize-root .actions .separator {\n  display: inline-block;\n  vertical-align: middle;\n  border-left: 1px solid #E3E3E3;\n  height: 32px;\n}\n.presize-root .actions .spacing {\n  display: inline-block;\n  margin: 0 8px;\n}\n.presize-root .actions .total .total-sign {\n  margin: 0 16px;\n}\n.presize-root .actions .total .red {\n  color: #AD6800;\n}\n.presize-root .actions .total .green {\n  color: #5AA64B;\n}\n.presize-root .matrix-2d + .actions {\n  margin-bottom: 8px;\n}\n.presize-root .edit-sizes-btn {\n  line-height: 38px;\n}\n/*# sourceMappingURL=Actions.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
